// src/hooks/useHighPerf.ts
import { useEffect, useState } from "react";
import {
  useHighPerfProfesoresReport,
  useHighPerfReservasReport,
  useHighPerfReservaFirmasReport,
} from "./useReportJob";
import type { HpProfesoresResult, HpReservasResult, HpReservaFirmasResult } from "../api/reports";

/** Mapea estado del polling a {data,isFetching,error} */
function toState<R>(status?: {
  progress: number;
  done: boolean;
  failed: boolean;
  result: R | null;
}) {
  const isFetching = !status || (!status.done && !status.failed);
  const data = (status?.result as any)?.rows ?? [];
  return { data, isFetching };
}

/* ==================== Profesores HP ==================== */
export function useHpProfesores(desde?: string, hasta?: string) {
  const { run, useStatus } = useHighPerfProfesoresReport();
  const [jobId, setJobId] = useState<string | undefined>(undefined);
  const status = useStatus(jobId);

  useEffect(() => {
    let alive = true;
    async function fire() {
      if (!desde || !hasta) return setJobId(undefined);
      const { jobId } = await run({ desde, hasta });
      if (alive) setJobId(jobId);
    }
    void fire();
    return () => {
      alive = false;
    };
  }, [desde, hasta, run]);

  return toState<HpProfesoresResult>(status.data);
}

/* ==================== Reservas HP por profesor ==================== */
export function useHpReservas(profesorId?: number, desde?: string, hasta?: string) {
  const { run, useStatus } = useHighPerfReservasReport();
  const [jobId, setJobId] = useState<string | undefined>(undefined);
  const status = useStatus(jobId);

  useEffect(() => {
    let alive = true;
    async function fire() {
      if (!profesorId || !desde || !hasta) return setJobId(undefined);
      const { jobId } = await run({ profesorId, desde, hasta });
      if (alive) setJobId(jobId);
    }
    void fire();
    return () => {
      alive = false;
    };
  }, [profesorId, desde, hasta, run]);

  return toState<HpReservasResult>(status.data);
}

/* ==================== Firmas por reserva HP ==================== */
export function useHpReservaFirmas(reservaId?: number) {
  const { run, useStatus } = useHighPerfReservaFirmasReport();
  const [jobId, setJobId] = useState<string | undefined>(undefined);
  const status = useStatus(jobId);

  useEffect(() => {
    let alive = true;
    async function fire() {
      if (!reservaId) return setJobId(undefined);
      const { jobId } = await run({ reservaId });
      if (alive) setJobId(jobId);
    }
    void fire();
    return () => {
      alive = false;
    };
  }, [reservaId, run]);

  return toState<HpReservaFirmasResult>(status.data);
}
